import { useSelector } from "react-redux";

export const NUCLEUS_STAFF_USER = "NUCLEUS_STAFF_USER";
export const REBATES_ADMIN = "REBATES_ADMIN";
export const REBATES_GROUPS_ADMIN = "REBATES_GROUPS_ADMIN";
export const MODEL_PORTFOLIO_USER = "MODEL_PORTFOLIO_USER";
export const TRANSACTIONS_ROLE = "sonata-client-transaction";
export const ADVISER_ROLE = "sonata-agent";

export const isTransactionsEnabled = (roles = []) => roles.includes(TRANSACTIONS_ROLE);
export const isAdviser = (roles = []) => roles.includes(ADVISER_ROLE);

export function useRoles(requiredRole) {
    const roles = useSelector(state => state?.user?.roles ?? []);
    return requiredRole ? roles.includes(requiredRole) : true;
}
